import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { WEALTH_ROUTES } from '@egw/constants'
import { Activity } from './index'

export interface CheckingActivityPageProps {
  alias: number
}

export const CheckingActivityPage: FC<CheckingActivityPageProps> = ({ alias }) => {
  const { t } = useTranslation('features-transactions')
  return (
    <Activity
      alias={alias}
      title={t('account_activity.title')}
      backLinkUrl={WEALTH_ROUTES.CHECKING_ACCOUNT_ACTIVITY.backPath?.replace(':alias', alias.toString()) ?? ''}
    />
  )
}
